import { Link } from "react-router-dom";
import { navigation } from "../../data/site";
import Container from "./Container";
import SocialLinks from "../ui/SocialLinks";

export default function Footer() {
  return (
    <footer className="border-t border-[var(--line)]">
      <Container className="flex flex-col gap-6 py-8 lg:flex-row lg:items-center lg:justify-between">
        <p className="text-sm text-[var(--muted)]">© {new Date().getFullYear()} Imran Melikov</p>
        <nav aria-label="Footer" className="flex flex-wrap gap-x-5 gap-y-2">
          {navigation.map((item) => (
            <Link key={item.href} to={item.href} className="footer-link text-sm">
              {item.label}
            </Link>
          ))}
        </nav>
        <SocialLinks />
      </Container>
    </footer>
  );
}
